export default __webpack_public_path__ + "content/media/33.7f95a64c.jpg";